'use client';

import { c as _c } from "react/compiler-runtime";
import { createContext, useContext, useMemo, useState } from 'react';
import type { TopNavItem } from './TopNavProps';
import { type TopNavProps } from './TopNavProps';
interface TopNavContextType extends TopNavProps {
  expandedMenu: TopNavItem | null;
  setExpandedMenu: (menu: TopNavItem | null) => void;
  isExpanded: boolean;
  setExpanded: (isExpanded: boolean) => void;
  isMobileSubExpanded: boolean;
  setMobileSubExpanded: (isExpanded: boolean) => void;
}
export const TopNavContext = createContext<TopNavContextType>({
  isMobileSubExpanded: false,
  setMobileSubExpanded: () => {},
  expandedMenu: null,
  setExpandedMenu: () => {},
  isExpanded: false,
  setExpanded: () => {}
});
export const TopNavProvider = t0 => {
  const $ = _c(8);
  const {
    children,
    topNavProps
  } = t0;
  const [isExpanded, setExpanded] = useState(false);
  const [isMobileSubExpanded, setMobileSubExpanded] = useState(false);
  const [expandedMenu, setExpandedMenu] = useState(null);
  let t1;
  if ($[0] !== expandedMenu || $[1] !== isExpanded || $[2] !== isMobileSubExpanded || $[3] !== topNavProps) {
    t1 = {
      ...topNavProps,
      isExpanded,
      setExpanded,
      isMobileSubExpanded,
      setMobileSubExpanded,
      expandedMenu,
      setExpandedMenu
    };
    $[0] = expandedMenu;
    $[1] = isExpanded;
    $[2] = isMobileSubExpanded;
    $[3] = topNavProps;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const value = t1;
  let t2;
  if ($[5] !== children || $[6] !== value) {
    t2 = <TopNavContext.Provider value={value}>{children}</TopNavContext.Provider>;
    $[5] = children;
    $[6] = value;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
};
export const useTopNav = () => {
  const context = useContext(TopNavContext);
  if (!context) {
    throw new Error("useTopNav must be used within a TopNavProvider");
  }
  return context;
};